define([
    "jquery",
    "underscore",
    "marionette",
    "views/common/datatables_view",
    "bootstrap.datepicker",
    "datatables"
], function($, _, Marionette){
    let datatable;
    return Marionette.LayoutView.extend({
        el: '#content_layout',

        ui: {
            'searchBtn': '.search-btn',
            'today': '#search-today',
            'yesterday': '#search-yesterday',
            'lastWeek': '#search-last-week',
            'lastMonth': '#search-last-month',
            'startDate': '#search-start-date',
            'endDate': '#search-end-date',
            'type': '#search-type',
            'search': '#search-btn',
            'datatables': '#datatables',
        },

        events: {
            'click @ui.search': 'draw_datatable',
            'click @ui.today': 'date_today',
            'click @ui.yesterday': 'date_yesterday',
            'click @ui.lastWeek': 'date_last_week',
            'click @ui.lastMonth': 'date_last_month',
            'click @ui.searchBtn': 'trigger_active_class',
        },

        initialize: function(){
            $(this.ui.startDate).datetimepicker({
                format: 'YYYY-MM-DD'
            }).on('dp.change', this.remove_active_class);
            $(this.ui.endDate).datetimepicker({
                format: 'YYYY-MM-DD'
            }).on('dp.change', this.remove_active_class);

            this.bindUIElements();
            let columns =[
                {
                    'name':'reg_datetime',
                    'data':'reg_datetime',
                    'type': 'date'
                },
                {
                    'name':'type',
                    'data':'type'
                },
                {
                    'name':'remark',
                    'data':'remark'
                },
                {
                    'name':'deposit_amount',
                    'data':'deposit_amount',
                    'orderable': false
                },
                {
                    'name':'withdrawal_amount',
                    'data':'withdrawal_amount',
                    'orderable': false
                }
            ];

            let that= this;
            datatable = this.ui.datatables.DataTable({
                'searching': false,
                'ordering': true,
                'stateSave': false,
                'columns': columns,
                'deferRender': true,
                'serverSide': true,
                'pageLength': 10, // nbPerPage,
                'processing': true,
                'ajax': {
                    type: "POST",
                    url: baseUrl + '/rest_wallet/transfer_history',
                    data: function (data) {
                        data.filters = {
                            type: that.ui.type.val(),
                            start_date: that.ui.startDate.val(),
                            end_date: that.ui.endDate.val()
                        }
                    }
                },
                language:{
                    url: baseUrl+'/assets/common/common/js/libs/DataTables/languages/'+lang+'.json'
                }
            });
        },

        trigger_active_class: function(e) {
            this.remove_active_class();
            $(e.target).addClass('active');
        },

        remove_active_class: function() {
            $('.search-btn').removeClass('active');
        },

        draw_datatable: function() {
            if (datatable) {
                datatable.draw();
            }
        },

        date_today: function() {
            let today = new Date();
            today = this.format_date(today);

            this.ui.startDate.val(today);
            this.ui.endDate.val(today);
        },

        date_yesterday: function() {
            let date = new Date();
            date.setDate(date.getDate() - 1 );
            let yesterday = this.format_date(date);

            this.ui.startDate.val(yesterday);
            this.ui.endDate.val(yesterday);
        },

        date_last_week: function() {
            let date = new Date();
            date.setDate(date.getDate() - 7 );
            let last_week = this.format_date(date);

            this.ui.startDate.val(last_week);
            this.ui.endDate.val('');
        },

        date_last_month: function() {
            let date = new Date();
            date.setMonth(date.getMonth() - 1 );
            let last_month = this.format_date(date);

            this.ui.startDate.val(last_month);
            this.ui.endDate.val('');
        },

        format_date: function(date) {
            let day = date.getDate();
            let month = date.getMonth() + 1; //Months are zero based
            let year = date.getFullYear();

            if (month < 10) {
                month = '' + 0 + month;
            }
            if (day < 10) {
                day = '' + 0 + day;
            }
            return year + "-" + month + "-" + day;
        }
    });
});
